module.exports = __webpack_public_path__ + "0024e83081329c35f60c159798bd80aa.png";